import * as React from 'react';
import { FormattedDate } from 'react-intl';
import * as styles from './BlogEntryHero.module.scss';

export type BlogEntryHeroProps = {
    title: string | React.ReactNode;
    date?: string | number | Date;
    image: React.ReactNode;
    dateIcon?: React.ReactNode;
    writtenBy?: React.ReactNode;
    author?: React.ReactNode;
};

function BlogEntryHero({
    title,
    date,
    image,
    dateIcon,
    writtenBy,
    author,
}: BlogEntryHeroProps): React.ReactElement {
    const formattedDate = date ? new Date(date) : '';
    if (formattedDate) {
        formattedDate.setMinutes(
            formattedDate.getMinutes() + formattedDate.getTimezoneOffset(),
        );
    }

    /* eslint-disable react/no-danger */
    return (
        <section className={styles.root}>
            {image}
            <aside className={styles.date}>
                {formattedDate && (
                    <FormattedDate value={formattedDate} dateStyle="long" />
                )}
                {dateIcon}
            </aside>
            <div className={styles.titleWrapper}>
                {typeof title === 'string' ? (
                    <h1 dangerouslySetInnerHTML={{ __html: title }} />
                ) : (
                    <h1>{title}</h1>
                )}
                <div className={styles.writtenBy}>
                    {writtenBy}
                    {author}
                </div>
            </div>
        </section>
    );
}

export default BlogEntryHero;
